<a [routerLink]="link" *ngIf="blog">
    <article
        class="card pf-card -hover"
        [attr.itemprop]="'Blog'"
        [attr.itemscope]
        [attr.itemtype]="'http://schema.org/BlogPosting'"
    >
        <img
            [attr.itemprop]="'image'"
            class="card-img-top img-fluid lazyload"
            [attr.data-src]="
                blog.featured_image
                    ? blog.featured_image
                    : '/ng-assets/blog/thumbnail-v1.jpg'
            "
            [alt]="blog.title"
            loading="lazy"
        />
        <div class="card-body">
            <time
                class="pf-card__sub -shiftup"
                [attr.itemprop]="'datePublished'"
                attr.content="{{ blog.date | date: 'yyyy-MM-ddT13:08:00' }}"
                >{{ blog.date | date: "mediumDate" }}</time
            >
            <h3
                class="sg-heading__h4 mb-3"
                [ngClass]="{ '-lightFont': cardStyle }"
                [attr.itemprop]="headline"
            >
                {{ blog.title }}
            </h3>
            <p
                class="pf-card__description"
                [attr.itemprop]="description"
                *ngIf="showDescription"
            >
                {{ blog.meta_description }}
            </p>
            <div class="card-text">
                <ng-content></ng-content>
            </div>
        </div>
    </article>
</a>
